import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_7 = {
  key: 2,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = { class: "form-floating mb-3" }
const _hoisted_15 = { class: "form-floating mb-3 position-relative" }
const _hoisted_16 = ["type"]
const _hoisted_17 = { class: "material-symbols-outlined" }
const _hoisted_18 = { class: "form-floating mb-3 position-relative" }
const _hoisted_19 = ["type"]
const _hoisted_20 = { class: "material-symbols-outlined" }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { class: "form-floating mb-3" }
const _hoisted_23 = { class: "form-floating mb-3" }
const _hoisted_24 = { class: "form-group mb-3" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_27 = { class: "form-group mb-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_30 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center py-1"
}
const _hoisted_31 = { class: "material-symbols-outlined text-white fs-20 me-2" }
const _hoisted_32 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "register"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "fs-28 mb-2" }, "Registrati", -1)),
          _cache[27] || (_cache[27] = _createElementVNode("p", { class: "fw-medium fs-16 mb-4" }, " Crea il tuo account per calcolare la tua rata ", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.showVerificationStep ? _ctx.handleVerification() : _ctx.handleRegister()), ["prevent"])),
            class: "auth-form"
          }, [
            (_ctx.apiError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.apiError), 1))
              : _createCommentVNode("", true),
            (_ctx.passwordError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.passwordError), 1))
              : _createCommentVNode("", true),
            (_ctx.verificationSent && _ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Ti abbiamo inviato un codice di verifica all'indirizzo " + _toDisplayString(_ctx.email) + ". Inseriscilo qui sotto per completare la registrazione. ", 1))
              : _createCommentVNode("", true),
            (!_ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "registerFirstName",
                          placeholder: "Inserisci il tuo nome",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.firstName]
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "registerFirstName" }, "Nome", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "registerLastName",
                          placeholder: "Inserisci il tuo cognome",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.lastName]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "registerLastName" }, "Cognome", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "registerEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", { for: "registerEmail" }, "Indirizzo Email", -1))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.passwordFieldType,
                      class: "form-control",
                      id: "registerPassword",
                      placeholder: "Inserisci la password",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validatePasswords && _ctx.validatePasswords(...args))),
                      required: ""
                    }, null, 40, _hoisted_16), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("label", { for: "registerPassword" }, "Password", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                    }, [
                      _createElementVNode("i", _hoisted_17, _toDisplayString(_ctx.isPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.passwordConfirmationFieldType,
                      class: "form-control",
                      id: "registerPasswordConfirmation",
                      placeholder: "Conferma la password",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validatePasswords && _ctx.validatePasswords(...args))),
                      required: ""
                    }, null, 40, _hoisted_19), [
                      [_vModelDynamic, _ctx.passwordConfirmation]
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("label", { for: "registerPasswordConfirmation" }, "Conferma Password", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordConfirmationVisibility && _ctx.togglePasswordConfirmationVisibility(...args)))
                    }, [
                      _createElementVNode("i", _hoisted_20, _toDisplayString(_ctx.isPasswordConfirmationVisible ? 'visibility_off' : 'visibility'), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "verifyEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event)),
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("label", { for: "verifyEmail" }, "Indirizzo Email", -1))
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "verificationCode",
                      placeholder: "Inserisci il codice di verifica",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.verificationCode) = $event)),
                      maxlength: "6",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.verificationCode]
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("label", { for: "verificationCode" }, "Codice di Verifica", -1))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link p-0 text-decoration-none",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args))),
                      disabled: _ctx.resendLoading
                    }, [
                      (_ctx.resendLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _cache[22] || (_cache[22] = _createTextVNode(" Non hai ricevuto il codice? Invia di nuovo ", -1))
                    ], 8, _hoisted_25)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary fw-medium py-2 px-3 w-100",
                disabled: _ctx.isLoading || (!_ctx.showVerificationStep && !!_ctx.passwordError)
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("i", _hoisted_31, _toDisplayString(_ctx.showVerificationStep ? 'verified_user' : 'person_4'), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.showVerificationStep ? 'Verifica Email' : 'Registrati'), 1)
                    ]))
              ], 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[25] || (_cache[25] = _createElementVNode("p", null, [
                _createTextVNode(" Confermando la tua email, accetti i nostri "),
                _createElementVNode("a", {
                  href: "https://smartrate.it/termini-e-condizioni-generali-di-servizio",
                  target: "_blank",
                  class: "fw-medium text-decoration-none"
                }, " Termini di Servizio "),
                _createTextVNode(" e di aver letto e compreso la nostra "),
                _createElementVNode("a", {
                  href: "https://smartrate.it/privacy-policy",
                  target: "_blank",
                  class: "fw-medium text-decoration-none"
                }, " Informativa Privacy")
              ], -1)),
              _createElementVNode("p", null, [
                _cache[24] || (_cache[24] = _createTextVNode(" Hai già un account? ", -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "fw-medium text-primary text-decoration-none",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.$emit('switch-to-login')), ["prevent"]))
                }, " Accedi ")
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}